module.exports = __webpack_public_path__ + "static/media/pat.48b50470.png";